import {ReactNode, useMemo} from 'react'
import {IOrder} from '../../apis/unknownorder/nft'
import {ComponentItem, CreateComponent} from '../useComponent'
import Text from '../text/Text'
import ContainerLayout from '../layout/ContainerLayout'
import WizTable from './TableFactory'
import {useTime} from '../../utils/time'
import {useDisplayNumber} from '../../utils/number'

interface IProps {
    data?: IOrder[]
    className?: string
}

const OrderContainer: React.FC<IProps> = ({data}) => {
    const {localTimeString} = useTime()
    const {toFixedNumber} = useDisplayNumber()
    const headerTitles: string[] = ['User ID', 'Status', 'Symbol', 'Amount', 'CreatedAt']
    const headers: ComponentItem[] = headerTitles.map<ComponentItem>(el => ({
        component: Text,
        props: {
            children: el,
        },
    }))
    const rows = useMemo(() => {
        if (data === undefined || data?.length === 0) {
            return []
        }

        return data?.map<ReactNode[]>(el => [
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.user_id})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.type})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.normalized_symbol})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.amount})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: localTimeString(el.created_at)})}
            </div>,
        ])
    }, [data, localTimeString])

    const {buy, sell, deposit, withdraw} = useMemo(() => {
        let res = {
            buy: 0,
            sell: 0,
            deposit: 0,
            withdraw: 0,
        }
        data?.forEach(el => {
            let vol = el.amount * el.price_in_base
            if (el.type === 'buy') {
                res.buy += vol
            } else if (el.type === 'sell') {
                res.sell += vol
            } else if (el.type === 'deposit') {
                res.deposit += vol
            } else if (el.type === 'withdraw') {
                res.deposit += vol
            }
        })
        return res
    }, [data])

    return (
        <ContainerLayout title="Orders">
            <div className="flex justify-end mb-4">
                <div>
                    <Text className={'mr-2 text-ti1 text-font03 text-right'}>Buy</Text>
                    <Text className={'mr-2 text-ti1 text-font01 text-right'}>{toFixedNumber(buy)}</Text>
                </div>
                <div>
                    <Text className={'mr-2 text-ti1 text-font03 text-right'}>Sell</Text>
                    <Text className={'mr-2 text-ti1 text-font01 text-right'}>{toFixedNumber(sell)}</Text>
                </div>
                <div>
                    <Text className={'mr-2 text-ti1 text-font03 text-right'}>Deposit</Text>
                    <Text className={'mr-2 text-ti1 text-font01 text-right'}>{toFixedNumber(deposit)}</Text>
                </div>
                <div>
                    <Text className={'mr-2 text-ti1 text-font03 text-right'}>Withdraw</Text>
                    <Text className={'mr-2 text-ti1 text-font01 text-right'}>{toFixedNumber(withdraw)}</Text>
                </div>
            </div>

            <WizTable gridCols="5" className="w-full" headers={headers} items={rows} />
        </ContainerLayout>
    )
}

export default OrderContainer
